// Actions
const SELECT = 'oms/exchange/SELECT';

const getInitialExchange = () => {
  if (global?.window?.location?.pathname?.includes('.SSE')) {
    return 'XSTO';
  }
  return 'XOSL';
};

// Reducer
const initialState = {
  selected: getInitialExchange(),
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SELECT:
      return {
        ...state,
        selected: action.exchange,
      };
    default:
      return state;
  }
}

// Action Creators
export function selectExchange(exchange) {
  return { type: SELECT, exchange };
}
